const resources = {
    freeReturns: 'Free Returns',
    exclusions: 'see details/exclusions.*',
    allPurchases: 'on all purchases.*'
};

module.exports = function getResource(label) {
    return resources[label];
};
